import moment, { Moment } from 'moment';
import { displayDate, ES_DATE_FORMAT } from 'utils/date';

export const getDisplayDate = (date: string | Moment) => {
  if (moment(date).isValid()) return displayDate(date, ES_DATE_FORMAT);
  else return date;
};
